import React from 'react'
import { Provider } from 'react-redux'

import AssetTabService from 'plugin-liverig/shared/asset/services/tab-service'

import store from '../store'
import EditorPage from './components'

import './deprecatedEditor'

const AlarmsTab = props => (
    <Provider store={store}>
        <EditorPage {...props} />
    </Provider>
)

AssetTabService.register({
    step: 'alarms',
    assetType: 'wells',
    label: 'Alarms',
    shouldHide: false,
    body: AlarmsTab
})
